import { zomatoService } from "./zomato";
import { swiggyService } from "./swiggy";

class PartnersOrderAggregator {
  constructor() {
    this.services = {
      zomato: zomatoService,
      swiggy: swiggyService,
    };
  }

  // Get all orders from all partners as a single array
  async getAllOrders(partners) {
    try {
      if (partners.length === 0) {
        return [];
      }

      const allOrders = [];

      for (const partner of partners) {
        const service = this.services[partner.toLowerCase()];
        if (!service) throw new Error("Invalid partner");

        const orders = await service.getOrders();
        allOrders.push(...orders);
      }
      // Flatten the array of arrays into a single array of orders
      return allOrders.flat();
    } catch (error) {
      console.error("Error fetching orders:", error);
      throw error;
    }
  }

  // Get a single order by its ID and partner
  async getOrder(orderId, partnerId) {
    try {
      const service = this.services[partnerId];
      if (!service) throw new Error("Invalid partner ID");

      return await service.getOrderDetails(orderId);
    } catch (error) {
      console.error(`Error fetching order ${orderId}:`, error);
      throw error;
    }
  }

  // Update outlet status
  async updateOutletStatus(isOpen) {
    try {
      if (isOpen) {
        await Promise.all(
          [
            this.services.zomato.reopenOutlet(),
            // Add Swiggy reopen if available
          ].filter(Boolean)
        );
      } else {
        await Promise.all([
          this.services.zomato.closeOutlet(),
          this.services.swiggy.closeOutlet(),
        ]);
      }
      return true;
    } catch (error) {
      console.error("Error updating outlet status:", error);
      throw error;
    }
  }
}

export const partnersOrderAggregator = new PartnersOrderAggregator();
